import _ from "lodash/fp";
import React from "react";
import {Glyphicon, OverlayTrigger, Table, Tooltip} from "react-bootstrap";
import SignDocuments from "./SignDocuments";
import { useTranslation } from 'react-i18next';

const tooltip = document => <Tooltip id="tooltip">{document.title}: {document.status || "unknown"}</Tooltip>;
const icon = status => {
  switch (status) {
    case "active":
    case "pending":
      return <Glyphicon glyph="ok" style={{color: "#f0ad4e"}} />;
    case "complete":
      return <Glyphicon glyph="ok" style={{color: "#5cb85c"}} />;
    case "rejectedBySigner":
    case "cancelled by merchant":
    case "expired":
      return <Glyphicon glyph="remove" style={{color: "#d9534f"}} />;
    case null:
    default:
      return <Glyphicon glyph="refresh" style={{color: "#f0ad4e"}} />;
  }
};

export default ({signtask, signers, documents}) => {
  const { t } = useTranslation();
  return (<Table striped bordered condensed hover>
    <thead>
    <tr>
      <th>{t("sign_task_signer_name")}</th>
      <th>{t("sign_task_signer_ssn")}</th>
      <th>{t("sign_task_signer_email")}</th>
      <th>{t("sign_task_signer_mobile")}</th>
      <th>{t("sign_task_signer_status")}</th>
    </tr>
    </thead>
    <tbody>
    {Object.entries(signers).map(([idx, signer]) => (
      <tr key={idx}>
        <td>{signer.name}</td>
        <td>{signer.ssn}</td>
        <td>{signer.email}</td>
        <td>{signer.phone}</td>
        <td>
          {(() => {
            const documents_ = _(signer.status)
              .mapValues(status => ({status}))
              .merge(documents)
              .values()
              .value();

            return (
              <span>
                {_.map(document => (
                  <OverlayTrigger key={document.reference} placement="bottom" overlay={tooltip(document)}>
                    {icon(document.status)}
                  </OverlayTrigger>
                ), documents_)}
              </span>
            );
          })()}
        </td>
      </tr>
    ))}
    </tbody>
  </Table>);
};